import { render } from "./vordermanage.vue?vue&type=template&id=17fbb52b&scoped=true"
import script from "./vordermanage.vue?vue&type=script&lang=js"
export * from "./vordermanage.vue?vue&type=script&lang=js"

import "./vordermanage.vue?vue&type=style&index=0&id=17fbb52b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fbb52b"]])

export default __exports__